module.exports = __webpack_public_path__ + "img/icon (13).e80fecb6.png";